module.exports = __webpack_public_path__ + "img/slide-bar-on_05.2b8de6dd.png";